import React from "react";
import "../components/Navigation/css/NavBar.scss";

export default function Community() {

    return (
        <></>
    )
}